import React from 'react';
import { DatePicker, Button, Space } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);         // let Day.js parse ‘YYYY-MM-DD’

const { RangePicker } = DatePicker;

/**
 * Format a {startDate, endDate} pair for the little grey label.
 */
export const formatDateRange = (range) => {
  if (!range) return 'All Time';

  const { startDate, endDate } = range;
  if (!startDate && !endDate) return 'All Time';

  const start = startDate ? dayjs(startDate).format('MMM YYYY') : '';
  const end   = endDate   ? dayjs(endDate).format('MMM YYYY') : '';

  return start && end ? `${start} – ${end}` : (start || end);
};

/**
 * Month range picker that stays in sync with React state.
 */
const DateRangeFilter = ({
  dateRange = { startDate: null, endDate: null },
  onChange,
  id = 'dateRangeFilter',
  style = {},
}) => {
  // Convert ISO strings → Day.js for the controlled picker value
  const value =
    dateRange.startDate && dateRange.endDate
      ? [dayjs(dateRange.startDate), dayjs(dateRange.endDate)]
      : null;

  const handleChange = (dates) => {
    if (!onChange) return;

    if (!dates || !dates.length) {
      onChange({ startDate: null, endDate: null });
    } else {
      onChange({
        startDate: dates[0].format('YYYY-MM-DD'),
        endDate:   dates[1].format('YYYY-MM-DD'),
      });
    }
  };

  return (
    <div className="date-range-filter">
      <div style={{ display: 'flex', alignItems: 'center' }}>

        <Space>
          <RangePicker
            id={id}
            picker="month"
            format="MMM YYYY"
            value={value}                // ← controlled, Day.js instances
            onChange={handleChange}
            allowClear
            style={{ width: 300, ...style }}
            ranges={{
              'Last Year':     [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
              'This Year':     [dayjs().startOf('year'), dayjs()],
              'Last 6 Months': [dayjs().subtract(6, 'month'), dayjs()],
              'Last 12 Months':     [dayjs().subtract(1, 'year'), dayjs()],
              
            }}
            disabledDate={(current) => current && current < dayjs('2023-01-01')}
          />

          {(dateRange.startDate || dateRange.endDate) && (
            <Button size="small" onClick={() => onChange?.({ startDate: null, endDate: null })}>
              Clear
            </Button>
          )}
        </Space>

        <span style={{ marginLeft: 10, color: '#666' }}>
          {formatDateRange(dateRange)}
        </span>
      </div>
    </div>
  );
};

export default DateRangeFilter;
